<template>
<div class="chapter">
<div class="inner_page">
<h2 id="sigil_toc_id_2"></h2>
<div>
<p class="tp2">BEYOND<br/>
    AWKWARD</p>
<p class="tp3">When Talking About Jesus<br/>
    Is Outside Your Comfort Zone</p>
<p class="tp4">BEAU CROSETTO</p>
<p class="tp3">Foreword by Dave Ferguson</p>
<p class="body"></p>
<p class="body"></p>
<div>
<br/>
</div>
<div>
<br/>
</div>
<div>
<br/>
</div>
<div>
<br/>
</div>
<div>
<br/>
</div>
<div>
<br/>
<p class="firstcenter"><img alt="IVP Books Imprint" src="Images/IVP_Books_Quarter.jpg"/></p>
<p class="center"><a href="http://www.IVPress.com/books" target="_blank">www.IVPress.com/books</a></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title_page.vue?ae6971c8